<template>
    <div>
        <div class="tab-header-container">
            <h2 class="form-label">Документи</h2>
            <LiteButton @click.native="addButtonClicked"
                        class="edit-button"
                        :hoverColor="'green'"
                        :icon="'far fa-plus-square'">
            </LiteButton>
        </div>

        <hr class="form-line"/>

        <DocumentList v-if="!shouldAdd"/>
        <DocumentCreateForm class="popup-shadow" v-if="shouldAdd" :workerId="parseInt(workerId)" @close-clicked="closedAddForm"/>
    </div>
</template>

<script>
    import DocumentList from "@/components/document/DocumentList";
    import LiteButton from "@/shared/components/button/LiteButton"
    import DocumentCreateForm from "@/components/document/DocumentCreateForm";

    export default {
        name: "WorkerDocuments",
        components: {DocumentCreateForm, DocumentList, LiteButton},
        data() {
          return {
              workerId: this.$route.params.id,
              shouldAdd: false,
          }
        },
        methods: {
            addButtonClicked() {
                this.$store.commit('setHasModal', true);
                this.shouldAdd = true;
            },
            closedAddForm() {
                this.$store.commit('setHasModal', false);
                this.shouldAdd = false;
            }
        }
    }
</script>

<style scoped>

</style>
